<template>
  <view-container>
    <v-card v-if="order">
      <v-card-text>
        <OrderForm v-model="order" no-correction />
      </v-card-text>
      <v-card-actions>
        <confirmation-dialog
          @confirm="correct"
          title="Внести исправления?"
          color="warning"
          :disabled="!confirm"
        >
          <template #text>
            Будет создано два новых чека -
            <strong>{{ correctionTypeName }}</strong> на сумму
            <strong> {{ parent.paymentAmount | currency }} </strong> и
            <strong>{{ orderTypeName }}</strong> на сумму
            <strong> {{ order.paymentAmount | currency }} </strong>.
            <v-checkbox
              label="подтверждаю действия"
              v-model="confirm"
            ></v-checkbox>
            <v-text-field
              name="comment"
              label="Комментарий"
              v-model="additionalInfo"
              clearable
            ></v-text-field>
          </template>
          <template #activator="{ on }">
            <v-btn color="warning" v-on="on" :disabled="!isValid">
              Исправить
            </v-btn>
          </template>
        </confirmation-dialog>
        <v-btn @click="cancel" text>Отмена</v-btn>
      </v-card-actions>
    </v-card>
  </view-container>
</template>
<script>
import ds from "@/datastore";
import OrderForm from "@/components/ui/forms/OrderForm";
import { getReceiptTypeName } from "@/datastore/enums";
export default {
  name: "OrderCorrect",
  components: { OrderForm },
  props: ["groupId", "orderId"],
  data() {
    return {
      parent: null,
      order: null,
      confirm: false,
      additionalInfo: "Исправление чека"
    };
  },
  computed: {
    isValid() {
      return this.order.isValid();
    },
    correctionTypeName() {
      return getReceiptTypeName(this.parent.correctionReceiptType);
    },
    orderTypeName() {
      return getReceiptTypeName(this.order.receipt.receiptType);
    }
  },
  methods: {
    cancel() {
      this.$router.go(-1);
      this.$destroy();
    },
    async correct() {
      if (!this.order.validatePaymentAmount()) {
        this.$store.commit(
          "notifications/error",
          "Введеная сумма оплаты не совпадает с суммой предметов расчета"
        );
        return;
      }
      let status = await this.parent.cancel({ timeout: 20, mandatory: true });
      if (status.status != "processed") {
        throw Error("Не удалось отменить предыдущий чек");
      }
      status = await this.order.registration({
        parentId: this.parent.orderId,
        timeout: 20,
        mandatory: true
      });
      if (status.status == "processed") {
        this.$store.commit(
          "notifications/success",
          "Созданы чеки, отменяющие и корректирующие операцию."
        );
        this.$router.replace({
          name: "order-details",
          params: { groupId: status.groupId, orderId: status.orderId }
        });
        this.$destroy();
      }
    }
  },
  async created() {
    if (!this.orderId) {
      this.$destroy();
    }
    this.parent = await ds.find(
      "order",
      [this.groupId, this.orderId].join("/")
    );
    if (!this.parent) {
      this.$destroy();
    }
    if (!this.parent.isCorrectable()) {
      this.$destroy();
    }
    const number = this.parent.number || this.parent.orderId;
    this.$store.commit("setTitle", "Коррекция чека по заказу #" + number);
    this.order = this.parent.clone();
    this.order.cashierId = this.parent.cashierId;
    this.order.receipt.additionalProps = this.parent.registrationInfo.fiscalSign;
    this.order.receipt.additionalInfo = this.additionalInfo;
  },
  deactivated() {
    this.$destroy();
  }
};
</script>
